'use client';

import { useEffect, useState } from 'react';

export default function ProcessProgressBar() {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setWidth(pct);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className="pointer-events-none fixed left-0 top-0 z-[9999] h-[3px] w-full bg-black/[0.08]"
      aria-hidden
    >
      <div
        className="h-full bg-[#EC1C24] shadow-[0_0_8px_rgba(236,28,36,0.7)] transition-[width] duration-100 ease-linear"
        style={{ width: `${width}%` }}
      />
    </div>
  );
}
